import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10",
      d: "M10.195 20.794v3.347m0-7.571a5.16 5.16 0 0 1-5.153-5.153V5.653A5.16 5.16 0 0 1 10.195.5a5.16 5.16 0 0 1 5.153 5.153v5.764a5.16 5.16 0 0 1-5.153 5.153m0 4.224C4.856 20.794.5 16.464.5 11.098m19.39 0a9.7 9.7 0 0 1-6.082 9.005"
    }, null, -1)
  ]))]))
}
export default { render: render }